export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/8d7a4a1279cc5c5b789c843b41a99cd0.jpeg" 
              alt="DDR Construction Solutions" 
              className="h-16 w-auto mb-4 bg-white p-2 rounded"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Your one-stop source for all things construction. Quality workmanship and honest communication from start to finish.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="#home" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Home</a></li>
              <li><a href="#services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Services</a></li>
              <li><a href="#about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#projects" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Projects</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-4">Our Services</h4>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>New Construction</li>
              <li>Remodeling</li>
              <li>Custom Carpentry</li>
              <li>Roofing Services</li>
              <li>Decks &amp; Siding</li>
              <li>Flooring &amp; Painting</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="flex items-start">
                <i className="ri-phone-fill text-red-500 mt-1 mr-3 w-5 h-5 flex items-center justify-center"></i>
                <a href="tel:502-533-0524" className="hover:text-white transition-colors cursor-pointer">502-533-0524</a>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-fill text-red-500 mt-1 mr-3 w-5 h-5 flex items-center justify-center"></i>
                <a href="mailto:info@ddrconstructionsolutions.com" className="hover:text-white transition-colors cursor-pointer">info@ddrconstructionsolutions.com</a>
              </li>
              <li className="flex items-start">
                <i className="ri-time-fill text-red-500 mt-1 mr-3 w-5 h-5 flex items-center justify-center"></i>
                <span>Mon - Fri: 7:00 AM - 6:00 PM<br />Sat: 8:00 AM - 4:00 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <p className="text-gray-400 text-sm text-center">
            © 2026 DDR Construction Solutions. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}